import {Injectable} from '@angular/core';
import {PolicyWording} from '../../shared/models/policy.model';
import {EntityState, SignalEntityStore} from '../../shared/state/signal-entity.store';

export interface PolicyWordingState extends EntityState<PolicyWording> {
  distinctSectionList: string[];
}

@Injectable({ providedIn: 'root' })
export class PolicyWordingStore extends SignalEntityStore<PolicyWording, PolicyWordingState> {
  constructor() {
    super({
      name: 'policy-wording',
      idKey: 'wording_policy_id',
      initialState: { distinctSectionList: [] }
    });
  }
}
